// extracted by mini-css-extract-plugin
module.exports =  {"title":"gwfMCY","totalLine":"QzopVj","multipleTotalsRoot":"wYqfAZ","deprecatedDivider":"AxNBeY"};